import { FunctionComponent, useState, useEffect } from 'react';
import * as vp from 'vopay';
import styles from './PerformanceOverviewContainer.module.scss';
import { transactionOptions } from './PerformanceData';
import PerformanceOverviewTable from './performanceOverviewTable';
import useFetchPerformanceOverview from '../../../../hooks/useApi/useFetchPerformanceOverview';
import { useTranslation } from 'react-i18next';

const { Tabs, NoData, Box, SubTitle } = vp;

type PerformingTabContents = {
  Top: React.JSX.Element;
  Low: React.JSX.Element;
};
type PeriodTabContents = {
  Yearly: React.JSX.Element;
  Monthly: React.JSX.Element;
  Weekly: React.JSX.Element;
};

type FC = FunctionComponent;

const PerformanceOverviewContainer: FC = () => {
  const [performingTab, setPerformingTab] = useState<keyof PerformingTabContents>('Top');
  const [periodTab, setPeriodTab] = useState<keyof PeriodTabContents>('Yearly');
  const [performanceData, fetchPerformanceOverview] = useFetchPerformanceOverview({});
  const { t } = useTranslation('translations', { keyPrefix: 'HomePage.PerformanceOverviewWidget' });

  const handlePeriodTabClick = (tab: keyof PeriodTabContents) => {
    setPeriodTab(tab);
  };

  const handlePerformingTabClick = (tab: keyof PerformingTabContents) => {
    setPerformingTab(tab);
  };

  useEffect(() => {
    fetchPerformanceOverview();
  }, []);

  return (
    <div className={styles.container}>
      <SubTitle subTitle={t('title')} variant="bold" />
      <Box flx="col" mt="md">
        <Tabs
          variant="chart"
          tabs={[
            {
              label: t('topPerformingTab'),
              onClick: () => handlePerformingTabClick('Top'),
            },
            {
              label: t('lowPerformingTab'),
              onClick: () => handlePerformingTabClick('Low'),
            },
          ]}
        />

        {performanceData.Statistics && Object.keys(performanceData.Statistics).length !== 0 ? (
          <div
            className={
              Object.keys(performanceData.Statistics).length > 5 ? styles.tableContainerScroll : styles.tableContainer
            }
          >
            <PerformanceOverviewTable
              transactionOptions={transactionOptions}
              performingTab={performingTab}
              periodTab={periodTab}
              performanceData={performanceData}
            />
          </div>
        ) : (
          <NoData />
        )}

        <Tabs
          variant="chart"
          tabs={[
            {
              label: t('yearlyTab'),
              onClick: () => handlePeriodTabClick('Yearly'),
            },
            {
              label: t('monthlyTab'),
              onClick: () => handlePeriodTabClick('Monthly'),
            },
            {
              label: t('weeklyTab'),
              onClick: () => handlePeriodTabClick('Weekly'),
            },
          ]}
        />
      </Box>
    </div>
  );
};

export default PerformanceOverviewContainer;
